import React from 'react';
import { Link } from 'react-router-dom';
import mobilierImage from '../images/mobilier-square.jpg';
import horlogerieImage from '../images/montres-square.jpg';
import bijouxImage from '../images/bijoux-square.png';
import jouetsImage from '../images/jouets-square.png';
import militaireImage from '../images/militaire-square.png';
import artImage from '../images/tableaux-square.jpg';
import porcelaineImage from '../images/ceramique-square.png';
import tapisserieImage from '../images/tapis.JPG';
import artAsiatiquesImage from '../images/asiat-square.png';
import sculptureImage from '../images/sculpture-square.jpg';
import argenterieImage from '../images/argenterie-square.png';
import instrumentsImage from '../images/musique-square.png';
import vinsImage from '../images/vin-square.png';
import voitureImage from '../images/voiture-square.png';
import monnaieImage from '../images/monnaie-square.png';

function ObjetsPage() {
    const items = [
        { name: 'Mobilier', image: mobilierImage, path: '/mobilier' },
        { name: 'Horlogerie', image: horlogerieImage, path: '/horlogerie' },
        { name: 'Bijoux', image: bijouxImage, path: '/bijoux' },
        { name: 'Jouets', image: jouetsImage, path: '/jouets' },
        { name: 'Militaire', image: militaireImage, path: '/militaire' },
        { name: 'Art', image: artImage, path: '/art' },
        { name: 'Céramique & Pâtes de Verre', image: porcelaineImage, path: '/porcelaine' },
        { name: 'Tapisserie', image: tapisserieImage, path: '/tapisserie' },
        { name: 'Arts Asiatiques', image: artAsiatiquesImage, path: '/arts-asiatiques' },
        { name: 'Sculpture', image: sculptureImage, path: '/sculpture' },
        { name: 'Argenterie', image: argenterieImage, path: '/argenterie' },
        { name: 'Instrument de Musique', image: instrumentsImage, path: '/instrument-de-musique' },
        { name: 'Vin & Spiritueux', image: vinsImage, path: '/vin-et-spiritueux' },
        { name: 'Voitures', image: voitureImage, path: '/voitures' },
        { name: 'Monnaie', image: monnaieImage, path: '/monnaie' },
    ];

    return (
        <div className="duplicated-page">
            <h1>Objets</h1>
            <p>
                Découvrez les différentes catégories d'objets anciens que j'achète et évalue. Chaque objet a une histoire unique et une valeur à préserver. Si vous possédez des objets anciens à vendre, n'hésitez pas à me contacter pour une évaluation gratuite.
            </p>
            <p>
                Cliquez sur une catégorie pour en savoir plus.
            </p>
            <div className="card-grid">
                {items.map((item, index) => (
                    <Link to={item.path} key={index} className="card">
                        <div className="card-image">
                            <img src={item.image} alt={item.name} />
                            <div className="card-overlay">
                                <h3>{item.name}</h3>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            <style jsx>{`
                .duplicated-page {
                    padding: 50px 20px;
                    text-align: center;
                }

                .duplicated-page h1 {
                    font-size: 3rem;
                    margin-bottom: 40px;
                    color: #20453d;
                }
                
                .duplicated-page p {
                    font-size: 1.2rem;
                    line-height: 1.8;
                    margin-bottom: 20px;
                }

                /* Default (desktop) layout with 4 columns */
                .card-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 20px;
                    justify-content: center;
                    align-items: start;
                }

                /* Mobile: 2 columns per row */
                @media (max-width: 768px) {
                    .card-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                .card {
                    display: block;
                    text-decoration: none;
                    border-radius: 10px;
                    overflow: hidden;
                    position: relative;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                }

                .card:hover {
                    transform: scale(1.05);
                    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
                }

                .card-image {
                    position: relative;
                    width: 100%;
                    height: 200px;
                    overflow: hidden;
                }

                .card-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }

                .card:hover img {
                    transform: scale(1.1);
                }

                /* Always display overlay (name always visible) */
                .card-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: rgba(0, 0, 0, 0.5);
                    opacity: 1;
                }

                .card-overlay h3 {
                    color: #fff;
                    font-size: 1.5rem;
                    text-align: center;
                    padding: 0 10px;
                }
            `}</style>
        </div>
    );
}

export default ObjetsPage;
